module.exports = __webpack_public_path__ + "img/disagree.11c0af4b.png";